var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import Dropdown from '../dropdown';
import Icon from '../icon';
import Input from '../input';
import { Styled } from './style';
var DropdownAddition = /** @class */ (function (_super) {
    __extends(DropdownAddition, _super);
    function DropdownAddition(props) {
        var _this = _super.call(this, props) || this;
        _this.clearSearch = function () {
            _this.setState({ searchQuery: '', open: false });
        };
        _this.handleSearchChange = function (e, d) {
            _this.setState({ searchQuery: d.value });
        };
        _this.handleDropdownChange = function (e, d) {
            var result = _this.props.options.find(function (option) { return option.value === d.value; });
            if (d.value && result) {
                _this.setState({
                    selectedValue: d.value,
                    selectedOption: result,
                    open: false,
                });
            }
            if (_this.props.onChange) {
                _this.props.onChange(e, d);
            }
        };
        _this.handleAddition = function (e, d) {
            var newOptionValue = d.value.replace(' ', '-').toLowerCase();
            var newItem = { key: newOptionValue, text: d.value, value: newOptionValue };
            _this.setState({
                options: __spreadArrays([newItem], _this.state.options),
                selectedValue: newOptionValue,
                selectedOption: newItem,
            });
            if (_this.props.onAddItem) {
                _this.props.onAddItem(e, d);
            }
        };
        _this.getFilteredOption = function () {
            var _a = _this.state, options = _a.options, searchQuery = _a.searchQuery;
            if (!searchQuery || !searchQuery.trim()) {
                return options;
            }
            var compareQuery = searchQuery.toLowerCase().trim();
            var getSearchFunction = function (_a) {
                var text = _a.text, keywords = _a.keywords;
                if (typeof text === 'string') {
                    return text
                        .toLowerCase()
                        .trim()
                        .includes(compareQuery);
                }
                else {
                    return keywords && keywords.some(function (keyword) { return keyword.toLowerCase().includes(compareQuery); });
                }
            };
            return options.filter(getSearchFunction);
        };
        _this.state = {
            options: _this.props.options,
            selectedValue: props.value ? props.value : '',
            selectedOption: (props.value && props.options.find(function (option) { return option.value === _this.props.value; })) || props.options[0],
            searchQuery: '',
            open: _this.props.open ? _this.props.open : false,
        };
        _this.containerDiv = React.createRef();
        return _this;
    }
    DropdownAddition.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.options !== prevState.options) {
            return {
                options: nextProps.options,
                selectedValue: nextProps.value,
                selectedOption: (nextProps.value && nextProps.options.find(function (option) { return option.value === nextProps.value; })) ||
                    nextProps.options[0],
            };
        }
        return null;
    };
    DropdownAddition.prototype.componentDidMount = function () {
        if (this.props.autoFocus) {
            this.containerDiv.current.focus();
        }
    };
    DropdownAddition.prototype.render = function () {
        var _this = this;
        var customSearchInput = (React.createElement(React.Fragment, null,
            this.props.icon && React.createElement(Icon, { name: this.props.icon }),
            React.createElement("div", { className: "current-group" }, this.state.selectedOption.text),
            React.createElement(Input, { placeholder: this.props.placeholder || 'Search or create new group', icon: this.state.searchQuery.length > 0 ? (React.createElement(Icon, { name: "remove-fill", color: "#CCC", onClick: this.clearSearch })) : (React.createElement(Icon, { name: "plus-fill", color: "#CCC", style: { cursor: 'default' } })), onChange: this.handleSearchChange, value: this.state.searchQuery })));
        return (React.createElement(OutsideClickHandler, { onOutsideClick: function () { return _this.setState({ open: false }); } },
            React.createElement(Styled, { showDescription: this.props.showDescription, disableAddition: this.props.disableAddition, tabIndex: "1", ref: this.containerDiv },
                React.createElement(Dropdown, { text: this.state.selectedOption.description, placeholder: this.props.placeholder, selection: true, search: true, disabled: this.props.disabled, selectOnBlur: false, open: this.state.open, allowAdditions: true, additionLabel: React.createElement(Icon, { name: "plus-fill", color: "#CCC" }), value: this.state.selectedValue, options: this.getFilteredOption(), onAddItem: this.handleAddition, onClose: this.clearSearch, onChange: this.handleDropdownChange, searchInput: customSearchInput, searchQuery: this.state.searchQuery, upward: this.props.upward, onClick: function () { return _this.setState({ open: true }); } }))));
    };
    DropdownAddition.defaultProps = {
        upward: false,
    };
    return DropdownAddition;
}(React.Component));
export default DropdownAddition;
//# sourceMappingURL=index.js.map